import categories from "./fr/categories.json";
import error from "./fr/error.json";
import items from "./fr/items.json";
import lang from "./fr/lang.json";
import layout from "./fr/layout.json";
import live from "./fr/live.json";
import loki from "./fr/loki.json";
import media from "./fr/media.json";
import online from "./fr/online.json";
import organization from "./fr/organization.json";
import payouts from "./fr/payouts.json";
import preferences from "./fr/preferences.json";
import sales from "./fr/sales.json";
import search from "./fr/search.json";
import sidenav from "./fr/sidenav.json";
import user from "./fr/user.json";

const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

export default ({
    ...categories,
    ...countries.getNames("fr"),
    ...error,
    ...items,
    ...lang,
    ...layout,
    ...live,
    ...loki,
    ...media,
    ...online,
    ...organization,
    ...payouts,
    ...preferences,
    ...sales,
    ...search,
    ...sidenav,
    ...user
});
